module.exports = "https://community-app-cdn.topcoder.com/static-assets/images/a17952f7104e72d5fea83d12ea131d93.png";